module.exports = __webpack_public_path__ + "img/endless lecture.d05ac5ad.png";